/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-list-item[_ngcontent-%COMP%]{color:#51626f}.link-label[_ngcontent-%COMP%]{display:inline-block;margin-left:16px}.little[_ngcontent-%COMP%]{font-size:.8em}.disabled[_ngcontent-%COMP%]{color:#85919a;cursor:default;pointer-events:none}.disabled[_ngcontent-%COMP%]:hover{background:0 0}.active[_ngcontent-%COMP%]{background:#fff!important;border-left:4px solid #c30045;color:#c30045}.mobile-hidden[_ngcontent-%COMP%]{display:none}@media screen and (min-width:650px){.mobile-hidden[_ngcontent-%COMP%]{display:block}}"];
export { styles as styles };
